module.exports = __webpack_public_path__ + "img/7.d48d9f6c.png";